import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';

const StyledTableContainer = withStyles(theme => ({
  root: {
    minHeight: '180px',
    backgroundColor: '#f6f6f6',
    border: '1px solid #d5d5d5',
  },
}))(TableContainer);

const StyledTableCell = withStyles(theme => ({
  body: {
    fontSize: 16,
    border: 'none',
    fontFamily: "'Work Sans', sans-serif",
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    height: '50px',
    '&:nth-of-type(even)': {
      backgroundColor: 'white',
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    width: '100%',
    backgroundColor: '#f6f6f6',
    fontSize: '30px',
  },
  strong: {
    fontWeight: 500,
  },
});

export default function ItemReviewTable({ products, className }) {
  const classes = useStyles();

  return (
    <StyledTableContainer className={className}>
      <Table className={classes.table}>
        <TableBody>
          {products.map(product => {
            const unitTotal = (product.price * (product.quantity || 0)).toFixed(
              2,
            );
            const shippingTotal = (
              product.shipping * (product.quantity || 0)
            ).toFixed(2);
            const subTotal = (
              parseFloat(unitTotal, 10) + parseFloat(shippingTotal, 10)
            ).toFixed(2);
            return (
              <StyledTableRow key={product.label}>
                <StyledTableCell>
                  <span className={classes.strong}>{product.label}</span>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <span className={classes.strong}>Item Price: </span>$
                  {unitTotal}
                </StyledTableCell>
                <StyledTableCell align="center">
                  <span className={classes.strong}>Qty: </span>
                  {product.quantity}
                  {product.numTags > 1 && ` (X${product.numTags})`}
                </StyledTableCell>
                <StyledTableCell align="center">
                  <span className={classes.strong}>Shipping: </span>$
                  {shippingTotal}
                </StyledTableCell>
                <StyledTableCell align="right">
                  <span className={classes.strong}>Subtotal: </span>${subTotal}
                </StyledTableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
}
